<template>
  <modal background>
    <validable-form @submit="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ !!user ? "Edycja użytkownika" : "Nowy użytkownik" }}
          </p>
          <button
            class="delete"
            type="button"
            aria-label="close"
            @click="cancel"
          ></button>
        </header>

        <section class="modal-card-body content">
          <div class="field">
            <label class="label">Adres e-mail użytkownika</label>
            <control-input
              ref="mailAddress"
              rules="required|email"
              v-model.trim="mail"
              icon-left="fa-at"
              placeholder="login@example.com..."
            />
          </div>

          <label class="label">Uprawnienia</label>
          <tabs
            v-model="permissionCategory"
            :tabs="permissionCategories"
            boxed
            centered
          >
            <template v-slot:[category] v-for="(perms, category) in P">
              <table
                class="table is-fullwidth is-bordered permissions"
                :key="category"
              >
                <div class="permission-category">
                  {{ permissionCategories[category].title }}
                </div>
                <tbody>
                  <tr
                    v-for="(info, perm) in perms"
                    :key="perm"
                    :class="{ 'is-danger': info.danger }"
                  >
                    <td
                      :data-tooltip="
                        info.danger && 'Uprawnienie potencjalnie niebezpieczne'
                      "
                    >
                      <div class="level">
                        <div class="level-left">
                          <div>
                            <p
                              class="permission__name"
                              :class="{ 'has-text-danger': info.danger }"
                            >
                              {{ info.name }}
                            </p>
                            <p
                              class="permission__desc"
                              v-if="info.desc"
                              v-html="info.desc"
                            />
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="is-pulled-right">
                            <input
                              :id="`PERM_${perm}`"
                              type="checkbox"
                              class="switch"
                              :class="{ 'is-danger': info.danger }"
                              :checked="permissions[perm]"
                              :value="permissions[perm]"
                              @change="
                                permissions[perm] =
                                  $event.target.value === 'false'
                              "
                            />
                            <label :for="`PERM_${perm}`" />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </tabs>
        </section>

        <footer class="modal-card-foot">
          <button
            class="button is-success"
            :class="{ 'is-loading': submitting }"
            :disabled="submitting"
            type="submit"
          >
            <icon :name="!!user ? 'fa-save' : 'fa-plus'" />
            <span>{{ !!user ? "Zapisz" : "Dodaj" }}</span>
          </button>

          <button class="button" @click="cancel">Anuluj</button>
        </footer>
      </div>
    </validable-form>
  </modal>
</template>

<script>
import get from "lodash.get";

import { Modal } from "%modals";

// Fixme: these should be imported with { } braces, however it doesn't work
import WithServerValidation from "%mixins/WithServerValidation";

import { Icon, ValidableForm, ControlInput, Tabs } from "%helpers";

import P from "%const/permissions";

const FLAT_P = Object.values(P).flatMap(p => Object.keys(p));

export default {
  name: "user-modal",

  components: {
    Modal,
    Icon,
    ValidableForm,
    ControlInput,
    Tabs
  },

  mixins: [
    WithServerValidation({
      "mailAddress:UNIQUE": "Użytkownik o podanym adresie e-mail już istnieje"
    })
  ],

  data() {
    return {
      P,
      permissionCategories: {
        videos: {
          icon: "fa-video",
          title: "Zarządzanie materiałami TV"
        },
        program: {
          icon: "fa-list",
          title: "Zarządzanie programem"
        },
        messages: {
          icon: "fa-newspaper",
          title: "Zarządzanie ogłoszeniami"
        },
        static: {
          icon: "fa-paragraph",
          title: "Zarządzanie statyczną treścią strony"
        },
        administration: {
          icon: "fa-users-cog",
          title: "Administracja systemem"
        },
        diagnostics: {
          icon: "fa-stethoscope",
          title: "Diagnostyka systemu"
        }
      },
      permissionCategory: "videos",

      mail: "",
      permissions: FLAT_P.reduce((acc, curr) => {
        acc[curr] = false;
        return acc;
      }, {}),

      submitting: false
    };
  },

  props: {
    user: Object,
    authorities: Array,
    onSubmit: Function
  },

  mounted() {
    if (this.user) {
      this.mail = this.user.mailAddress;
      this.user.authorities.forEach(
        x => (this.permissions[x.permission] = true)
      );
    }
  },

  methods: {
    submit() {
      if (!this.submitting) {
        this.submitting = true;

        const user = {
          mailAddress:
            get(this.user, "mailAddress") === this.mail ? undefined : this.mail,
          authorities: Object.entries(this.permissions)
            .filter(p => p[1])
            .map(p => this.authorityByPermission(p[0]))
        };

        this.onSubmit(user, get(this.user, "mailAddress"))
          .then(() => this.cancel())
          .catch(this.handleValidationError)
          .finally(() => (this.submitting = false));
      }
    },

    authorityByPermission(permission) {
      return this.authorities.find(a => a.permission === permission);
    },

    cancel() {
      this.$emit("hide");
    }
  }
};
</script>

<style lang="scss" scoped>
.permissions {
  tr:nth-child(2n + 1) {
    background: $white-ter;
  }

  tr.is-danger {
    &:nth-child(2n) {
      background: transparentize($danger, 0.95);
    }

    &:nth-child(2n + 1) {
      background: transparentize($danger, 0.9);
    }
  }

  tr td {
    cursor: default;
  }

  .permission-category {
    text-align: center;
    font-weight: 700;
    margin: 0 0.5rem 0.5rem 0.5rem;
  }

  .permission {
    &__desc {
      font-size: 0.8rem;
      color: $grey;
    }
  }
}
</style>
